import { getApiPublicTabletServicesQueryOptions } from '@barbershop/api/customer'
import { Box } from '@chakra-ui/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { isBranchNotFoundError } from '@/entities/branch'
import { TabletCenterSpinner } from '@/widgets/tablet/loader'
import { TabletNotFoundState } from '@/widgets/tablet/not-found-state'

export const Route = createFileRoute('/_tablet-layout/branch/$id')({
    params: {
        parse: ({ id }) => {
            if (!/^\d+$/.test(id)) return false

            return { id: Number(id) }
        },
    },
    loader: async ({ context, params }) => {
        try {
            await context.queryClient.ensureQueryData(
                getApiPublicTabletServicesQueryOptions({ branch_id: params.id })
            )
        } catch (error) {
            if (isBranchNotFoundError(error)) throw notFound()
        }
    },
    pendingComponent: () => (
        <Box h='100dvh'>
            <TabletCenterSpinner title='Перебираем услуги' />
        </Box>
    ),
    notFoundComponent: () => <TabletNotFoundState variant='branch-not-found' />,
})
